import React from "react";
import "./contact.css";
import ScrollAnimation from "react-animate-on-scroll";

function Contact() {
  return (
    <div id="contact">
      <h5>Contacts</h5>

      <iframe
        title="Contact location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3921.897987234148!2d79.82206961451145!3d10.587148471837182!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5567c37a83f44b%3A0x6694d5a5e92448e!2sS.%20R.%20T%20Mango%20Kudoun!5e0!3m2!1sen!2sin!4v1663496898649!5m2!1sen!2sin"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowfullscreen=""
        loading="lazy"
      ></iframe>
      <h5>Contact info</h5>
      <div className="contact-info">
        <ScrollAnimation
          animateIn="animate__fadeInLeft"
          animateOut="animate__fadeOutRight"
        >
          <div className="contact-content">
            <i className="fa fa-map-marker " aria-hidden="true"></i>
            <div className="contact-message">
              <p className="bl-color">S.R.T Mango kudoun,</p>
              <p className="bl-color">Vizhunthamavadi,</p>
              <p className="bl-color">Nagapattinam,</p>
            </div>
          </div>
        </ScrollAnimation>
        <ScrollAnimation
          animateIn="animate__fadeInLeft"
          animateOut="animate__fadeOutRight"
        >
          <div className="contact-content">
            <i class="fa fa-phone" aria-hidden="true"></i>
            <div className="contact-message">
              <p className="bl-color">
                <a href="tel:6382112038">+91 63821 12038</a>
              </p>
              <p className="bl-color">artography2001@gmail.com</p>
            </div>
          </div>
        </ScrollAnimation>
      </div>
    </div>
  );
}

export default Contact;
